import React, { useState, useEffect } from "react";
import { Button, Typography, Box, styled, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import axios from "axios";
import utils from "../../utils";
import CliPagheTab from "./CliPagheTab";

const buttonStyles = {
  width: "100%",
  marginBottom: "10px",
  transition: "transform 0.2s ease, filter 0.2s ease",
  background: "#333",
  color: "white",
  textTransform: "capitalize",
};

const DashboardContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "250px",
  padding: "20px",
  borderRadius: "10px",
  background: "linear-gradient(to bottom, #1e1e1e, #353535)",
  boxShadow: "0px 0px 5px 0px #888888",
  color: "white",
  margin: "10px auto",
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
  },
}));

const buttonMap = {
  presenze: "Presenze",
  dipendenti: "Dipendenti",
  timbrature: "Timbrature",
  bustepaga: "Buste Paga",
  malattia: "Malattia",
  cassaintegrazione: "Cassa Integrazione",
};

const CliPaghe = () => {
  const [hovered, setHovered] = useState({});
  const [visibilita, setVisibilita] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const res = await axios.get("/api/me", {
        headers: utils.getAuthHeaders(),
        validateStatus: () => true,
      });
      if (res.status === 200) {
        const { success, me } = res.data;
        if (success && me.op) {
          window.location.href = "/op";
          return;
        }
        if (success) {
          if (me.visibilita == 'all') {
            setVisibilita('*');
          }
          const visPaghe = me.visibilita.split(',').filter(v => v.split(':')[0] == 'paghe')[0]
          if (visPaghe) {
            setVisibilita(visPaghe.split(':')[1]);
          }
          return;
        }
      }
    } catch (_) { }
    if (process.env.REACT_APP_ENV !== "test") {
      window.location.href = "/login?backto=%2Fcli%2Fpaghe";
    }
  };

  function renderLink(key) {
    if (visibilita != '*' & !visibilita.split('|').includes(key)) {
      return null;
    }
    const label = buttonMap[key];
    if (!label) return null;

    return (
      <Link to={`/cli/${key}`} style={{ textDecoration: "none" }} key={key}>
        <Button
          variant="contained"
          style={{
            ...buttonStyles,
            background: hovered === key ? "rgba(51, 51, 51, 0.8)" : "#333",
            transform: hovered === key ? "scale(1.05)" : "scale(1)",
            filter: hovered === key ? "brightness(1.2)" : "brightness(1)",
          }}
          onMouseEnter={() => setHovered(key)}
          onMouseLeave={() => setHovered("")}
        >
          {label}
        </Button>
      </Link>
    );
  }

  return (
    <Grid container spacing={0}>
      <Grid item xs={12} sm={6} md={3}>
        <DashboardContainer>
          <Typography variant="h5" align="center" gutterBottom mt={0}>
            Sezione Paghe
          </Typography>
          {Object.keys(buttonMap).map(key => renderLink(key))}
        </DashboardContainer>
      </Grid>

      <Grid item xs={12} sm={6} md={9} lg={9} xl={9}>
        <Box sx={{ margin: "10px" }}>
          <CliPagheTab />
        </Box>
      </Grid>
    </Grid>
  );
};

export default CliPaghe;
